export default __webpack_public_path__ + "static/media/three-eth.f0c5a0cd.svg";